import { render } from "./Task.vue?vue&type=template&id=65b9e254"
import script from "./Task.vue?vue&type=script&lang=js"
export * from "./Task.vue?vue&type=script&lang=js"

import "./Task.vue?vue&type=style&index=0&id=65b9e254&scope=true&lang=css"
script.render = render

export default script